

export default function CurriculaList(props){

    const { curricula, data, setData, setStandard } = props;

    const setCurriculum = c => {

        setData(c)
        setStandard(false)
      }

    return(
        curricula.map((c) => {
            const curriculaClass = c.id === data.id ? "map__heading--curricula-active" : ""
            return(
              <div key={c.id} className={`map__heading--curricula ${curriculaClass}`} onClick={() => setCurriculum(c)}>{c.title}</div>
            )
          })
    )


}